import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import page404EN from '404/translations/en.json';
import page404FR from '404/translations/fr.json';
import page404ES from '404/translations/es.json';
import page404ID from '404/translations/id.json';
import page404PA from '404/translations/pa.json';
import page404TH from '404/translations/th.json';
import page404ZHHANT from '404/translations/zh-hant.json';
import page404VI from '404/translations/vi.json';
import pageAboutEN from 'appExplainers/translations/en.json';
import pageAboutFR from 'appExplainers/translations/fr.json';
import pageAboutES from 'appExplainers/translations/es.json';
import pageAboutID from 'appExplainers/translations/id.json';
import pageAboutPA from 'appExplainers/translations/pa.json';
import pageAboutTH from 'appExplainers/translations/th.json';
import pageAboutZHHANT from 'appExplainers/translations/zh-hant.json';
import pageAboutVI from 'appExplainers/translations/vi.json';
import pageDocumentDisplayEN from 'documentDisplay/translations/en.json';
import pageDocumentDisplayFR from 'documentDisplay/translations/fr.json';
import pageDocumentDisplayES from 'documentDisplay/translations/es.json';
import pageDocumentDisplayID from 'documentDisplay/translations/id.json';
import pageDocumentDisplayPA from 'documentDisplay/translations/pa.json';
import pageDocumentDisplayTH from 'documentDisplay/translations/th.json';
import pageDocumentDisplayZHHANT from 'documentDisplay/translations/zh-hant.json';
import pageDocumentDisplayVI from 'documentDisplay/translations/vi.json';
import pageEcoachEN from 'eCoach/_translations/en.json';
import pageEcoachFR from 'eCoach/_translations/fr.json';
import pageEcoachES from 'eCoach/_translations/es.json';
import pageEcoachID from 'eCoach/_translations/id.json';
import pageEcoachPA from 'eCoach/_translations/pa.json';
import pageEcoachTH from 'eCoach/_translations/th.json';
import pageEcoachZHHANT from 'eCoach/_translations/zh-hant.json';
import pageEcoachVI from 'eCoach/_translations/vi.json';
import pageTeamLeadInsightsEN from 'teamLeadInsights/translations/en.json';
import pageTeamLeadInsightsFR from 'teamLeadInsights/translations/fr.json';
import pageTeamLeadInsightsES from 'teamLeadInsights/translations/es.json';
import pageTeamLeadInsightsID from 'teamLeadInsights/translations/id.json';
import pageTeamLeadInsightsPA from 'teamLeadInsights/translations/pa.json';
import pageTeamLeadInsightsTH from 'teamLeadInsights/translations/th.json';
import pageTeamLeadInsightsZHHANT from 'teamLeadInsights/translations/zh-hant.json';
import pageTeamLeadInsightsVI from 'teamLeadInsights/translations/vi.json';
import pageLayoutEN from 'layout/translations/en.json';
import pageLayoutFR from 'layout/translations/fr.json';
import pageLayoutES from 'layout/translations/es.json';
import pageLayoutID from 'layout/translations/id.json';
import pageLayoutPA from 'layout/translations/pa.json';
import pageLayoutTH from 'layout/translations/th.json';
import pageLayoutZHHANT from 'layout/translations/zh-hant.json';
import pageLayoutVI from 'layout/translations/vi.json';
import pageLoginEN from 'auth/translations/en.json';
import pageLoginFR from 'auth/translations/fr.json';
import pageLoginES from 'auth/translations/es.json';
import pageLoginID from 'auth/translations/id.json';
import pageLoginPA from 'auth/translations/pa.json';
import pageLoginTH from 'auth/translations/th.json';
import pageLoginZHHANT from 'auth/translations/zh-hant.json';
import pageLoginVI from 'auth/translations/vi.json';
import pageSettingsEN from 'settings/translations/en.json';
import pageSettingsFR from 'settings/translations/fr.json';
import pageSettingsES from 'settings/translations/es.json';
import pageSettingsID from 'settings/translations/id.json';
import pageSettingsPA from 'settings/translations/pa.json';
import pageSettingsTH from 'settings/translations/th.json';
import pageSettingsZHHANT from 'settings/translations/zh-hant.json';
import pageSettingsVI from 'settings/translations/vi.json';
import pageOnboardingEN from 'onboarding/translations/en.json';
import pageOnboardingFR from 'onboarding/translations/fr.json';
import pageOnboardingES from 'onboarding/translations/es.json';
import pageOnboardingID from 'onboarding/translations/id.json';
import pageOnboardingPA from 'onboarding/translations/pa.json';
import pageOnboardingTH from 'onboarding/translations/th.json';
import pageOnboardingZHHANT from 'onboarding/translations/zh-hant.json';
import pageOnboardingVI from 'onboarding/translations/vi.json';
import pageShiftNotesEN from 'shiftNotes/translations/en.json';
import pageShiftNotesFR from 'shiftNotes/translations/fr.json';
import pageShiftNotesES from 'shiftNotes/translations/es.json';
import pageShiftNotesID from 'shiftNotes/translations/id.json';
import pageShiftNotesPA from 'shiftNotes/translations/pa.json';
import pageShiftNotesTH from 'shiftNotes/translations/th.json';
import pageShiftNotesZHHANT from 'shiftNotes/translations/zh-hant.json';
import pageShiftNotesVI from 'shiftNotes/translations/vi.json';
import pagePrioritiesEN from 'priorities/translations/en.json';
import pagePrioritiesFR from 'priorities/translations/fr.json';
import pagePrioritiesES from 'priorities/translations/es.json';
import pagePrioritiesID from 'priorities/translations/id.json';
import pagePrioritiesPA from 'priorities/translations/pa.json';
import pagePrioritiesTH from 'priorities/translations/th.json';
import pagePrioritiesZHHANT from 'priorities/translations/zh-hant.json';
import pagePrioritiesVI from 'priorities/translations/vi.json';
import pageDemoRegistrationEN from 'demoRegistration/translations/en.json';
import pageDemoRegistrationFR from 'demoRegistration/translations/fr.json';
import pageDemoRegistrationES from 'demoRegistration/translations/es.json';
import pageDemoRegistrationID from 'demoRegistration/translations/id.json';
import pageDemoRegistrationPA from 'demoRegistration/translations/pa.json';
import pageDemoRegistrationTH from 'demoRegistration/translations/th.json';
import pageDemoRegistrationZHHANT from 'demoRegistration/translations/zh-hant.json';
import pageDemoRegistrationVI from 'demoRegistration/translations/vi.json';
import productTourEN from 'productTours/translations/en.json';
import productTourFR from 'productTours/translations/fr.json';
import productTourES from 'productTours/translations/es.json';
import productTourID from 'productTours/translations/id.json';
import productTourPA from 'productTours/translations/pa.json';
import productTourTH from 'productTours/translations/th.json';
import productTourZHHANT from 'productTours/translations/zh-hant.json';
import productTourVI from 'productTours/translations/vi.json';
import sidePanelEN from 'sidePanel/translations/en.json';
import sidePanelFR from 'sidePanel/translations/fr.json';
import sidePanelES from 'sidePanel/translations/es.json';
import sidePanelID from 'sidePanel/translations/id.json';
import sidePanelPA from 'sidePanel/translations/pa.json';
import sidePanelTH from 'sidePanel/translations/th.json';
import sidePanelZHHANT from 'sidePanel/translations/zh-hant.json';
import sidePanelVI from 'sidePanel/translations/vi.json';
import pwaEN from 'pwa/translations/en.json';
import pwaFR from 'pwa/translations/fr.json';
import pwaES from 'pwa/translations/es.json';
import pwaID from 'pwa/translations/id.json';
import pwaPA from 'pwa/translations/pa.json';
import pwaTH from 'pwa/translations/th.json';
import pwaZHHANT from 'pwa/translations/zh-hant.json';
import pwaVI from 'pwa/translations/vi.json';
import sharedEN from 'shared/translations/en.json';
import sharedFR from 'shared/translations/fr.json';
import sharedES from 'shared/translations/es.json';
import sharedID from 'shared/translations/id.json';
import sharedPA from 'shared/translations/pa.json';
import sharedTH from 'shared/translations/th.json';
import sharedZHHANT from 'shared/translations/zh-hant.json';
import sharedVI from 'shared/translations/vi.json';
import pageTeamEN from 'teamProfiles/translations/en.json';
import pageTeamFR from 'teamProfiles/translations/fr.json';
import pageTeamES from 'teamProfiles/translations/es.json';
import pageTeamID from 'teamProfiles/translations/id.json';
import pageTeamPA from 'teamProfiles/translations/pa.json';
import pageTeamTH from 'teamProfiles/translations/th.json';
import pageTeamZHHANT from 'teamProfiles/translations/zh-hant.json';
import pageTeamVI from 'teamProfiles/translations/vi.json';
import pageDashboardEN from 'dashboard/translations/en.json';
import pageDashboardFR from 'dashboard/translations/fr.json';
import pageDashboardES from 'dashboard/translations/es.json';
import pageDashboardID from 'dashboard/translations/id.json';
import pageDashboardPA from 'dashboard/translations/pa.json';
import pageDashboardTH from 'dashboard/translations/th.json';
import pageDashboardZHHANT from 'dashboard/translations/zh-hant.json';
import pageDashboardVI from 'dashboard/translations/vi.json';
import pageEventsEN from 'events/translations/en.json';
import pageEventsFR from 'events/translations/fr.json';
import pageEventsES from 'events/translations/es.json';
import pageEventsID from 'events/translations/id.json';
import pageEventsPA from 'events/translations/pa.json';
import pageEventsTH from 'events/translations/th.json';
import pageEventsZHHANT from 'events/translations/zh-hant.json';
import pageEventsVI from 'events/translations/vi.json';
import pageFormEN from 'form/translations/en.json';
import pageFormFR from 'form/translations/fr.json';
import pageFormES from 'form/translations/es.json';
import pageFormID from 'form/translations/id.json';
import pageFormPA from 'form/translations/pa.json';
import pageFormTH from 'form/translations/th.json';
import pageFormZHHANT from 'form/translations/zh-hant.json';
import pageFormVI from 'form/translations/vi.json';

import { SUPPORTED_LANGUAGES } from 'i18n/languages';

interface Resources {
  [key: string]: {
    [namespace: string]: Record<string, unknown>;
  };
}

const resources: Resources = {
  en: {
    page404: page404EN,
    pageAbout: pageAboutEN,
    pageDocumentDisplay: pageDocumentDisplayEN,
    pageEcoach: pageEcoachEN,
    pageTeamLeadInsights: pageTeamLeadInsightsEN,
    pageLayout: pageLayoutEN,
    pageLogin: pageLoginEN,
    pageSettings: pageSettingsEN,
    pageOnboarding: pageOnboardingEN,
    pageShiftNotes: pageShiftNotesEN,
    pagePriorities: pagePrioritiesEN,
    shared: sharedEN,
    pageDemoRegistration: pageDemoRegistrationEN,
    productTour: productTourEN,
    sidePanel: sidePanelEN,
    pwa: pwaEN,
    pageTeam: pageTeamEN,
    pageDashboard: pageDashboardEN,
    pageEvents: pageEventsEN,
    pageForm: pageFormEN,
  },
  fr: {
    page404: page404FR,
    pageAbout: pageAboutFR,
    pageDocumentDisplay: pageDocumentDisplayFR,
    pageEcoach: pageEcoachFR,
    pageTeamLeadInsights: pageTeamLeadInsightsFR,
    pageLayout: pageLayoutFR,
    pageLogin: pageLoginFR,
    pageSettings: pageSettingsFR,
    pageOnboarding: pageOnboardingFR,
    pageShiftNotes: pageShiftNotesFR,
    pagePriorities: pagePrioritiesFR,
    shared: sharedFR,
    pageDemoRegistration: pageDemoRegistrationFR,
    productTour: productTourFR,
    sidePanel: sidePanelFR,
    pwa: pwaFR,
    pageTeam: pageTeamFR,
    pageDashboard: pageDashboardFR,
    pageEvents: pageEventsFR,
    pageForm: pageFormFR,
  },
  es: {
    page404: page404ES,
    pageAbout: pageAboutES,
    pageDocumentDisplay: pageDocumentDisplayES,
    pageEcoach: pageEcoachES,
    pageTeamLeadInsights: pageTeamLeadInsightsES,
    pageLayout: pageLayoutES,
    pageLogin: pageLoginES,
    pageSettings: pageSettingsES,
    pageOnboarding: pageOnboardingES,
    pageShiftNotes: pageShiftNotesES,
    pagePriorities: pagePrioritiesES,
    shared: sharedES,
    pageDemoRegistration: pageDemoRegistrationES,
    productTour: productTourES,
    sidePanel: sidePanelES,
    pwa: pwaES,
    pageTeam: pageTeamES,
    pageDashboard: pageDashboardES,
    pageEvents: pageEventsES,
    pageForm: pageFormES,
  },
  id: {
    page404: page404ID,
    pageAbout: pageAboutID,
    pageDocumentDisplay: pageDocumentDisplayID,
    pageEcoach: pageEcoachID,
    pageTeamLeadInsights: pageTeamLeadInsightsID,
    pageLayout: pageLayoutID,
    pageLogin: pageLoginID,
    pageSettings: pageSettingsID,
    pageOnboarding: pageOnboardingID,
    pageShiftNotes: pageShiftNotesID,
    pagePriorities: pagePrioritiesID,
    shared: sharedID,
    pageDemoRegistration: pageDemoRegistrationID,
    productTour: productTourID,
    sidePanel: sidePanelID,
    pwa: pwaID,
    pageTeam: pageTeamID,
    pageDashboard: pageDashboardID,
    pageEvents: pageEventsID,
    pageForm: pageFormID,
  },
  th: {
    page404: page404TH,
    pageAbout: pageAboutTH,
    pageDocumentDisplay: pageDocumentDisplayTH,
    pageEcoach: pageEcoachTH,
    pageTeamLeadInsights: pageTeamLeadInsightsTH,
    pageLayout: pageLayoutTH,
    pageLogin: pageLoginTH,
    pageSettings: pageSettingsTH,
    pageOnboarding: pageOnboardingTH,
    pageShiftNotes: pageShiftNotesTH,
    pagePriorities: pagePrioritiesTH,
    shared: sharedTH,
    pageDemoRegistration: pageDemoRegistrationTH,
    productTour: productTourTH,
    sidePanel: sidePanelTH,
    pwa: pwaTH,
    pageTeam: pageTeamTH,
    pageDashboard: pageDashboardTH,
    pageEvents: pageEventsTH,
    pageForm: pageFormTH,
  },
  'zh-hant': {
    page404: page404ZHHANT,
    pageAbout: pageAboutZHHANT,
    pageDocumentDisplay: pageDocumentDisplayZHHANT,
    pageEcoach: pageEcoachZHHANT,
    pageTeamLeadInsights: pageTeamLeadInsightsZHHANT,
    pageLayout: pageLayoutZHHANT,
    pageLogin: pageLoginZHHANT,
    pageSettings: pageSettingsZHHANT,
    pageOnboarding: pageOnboardingZHHANT,
    pageShiftNotes: pageShiftNotesZHHANT,
    pagePriorities: pagePrioritiesZHHANT,
    shared: sharedZHHANT,
    pageDemoRegistration: pageDemoRegistrationZHHANT,
    productTour: productTourZHHANT,
    sidePanel: sidePanelZHHANT,
    pwa: pwaZHHANT,
    pageTeam: pageTeamZHHANT,
    pageDashboard: pageDashboardZHHANT,
    pageEvents: pageEventsZHHANT,
    pageForm: pageFormZHHANT,
  },
  pa: {
    page404: page404PA,
    pageAbout: pageAboutPA,
    pageDocumentDisplay: pageDocumentDisplayPA,
    pageEcoach: pageEcoachPA,
    pageTeamLeadInsights: pageTeamLeadInsightsPA,
    pageLayout: pageLayoutPA,
    pageLogin: pageLoginPA,
    pageSettings: pageSettingsPA,
    pageOnboarding: pageOnboardingPA,
    pageShiftNotes: pageShiftNotesPA,
    pagePriorities: pagePrioritiesPA,
    shared: sharedPA,
    pageDemoRegistration: pageDemoRegistrationPA,
    productTour: productTourPA,
    sidePanel: sidePanelPA,
    pwa: pwaPA,
    pageTeam: pageTeamPA,
    pageDashboard: pageDashboardPA,
    pageEvents: pageEventsPA,
    pageForm: pageFormPA,
  },
  vi: {
    page404: page404VI,
    pageAbout: pageAboutVI,
    pageDocumentDisplay: pageDocumentDisplayVI,
    pageEcoach: pageEcoachVI,
    pageTeamLeadInsights: pageTeamLeadInsightsVI,
    pageLayout: pageLayoutVI,
    pageLogin: pageLoginVI,
    pageSettings: pageSettingsVI,
    pageOnboarding: pageOnboardingVI,
    pageShiftNotes: pageShiftNotesVI,
    pagePriorities: pagePrioritiesVI,
    shared: sharedVI,
    pageDemoRegistration: pageDemoRegistrationVI,
    productTour: productTourVI,
    sidePanel: sidePanelVI,
    pwa: pwaVI,
    pageTeam: pageTeamVI,
    pageDashboard: pageDashboardVI,
    pageEvents: pageEventsVI,
    pageForm: pageFormVI,
  },
};

i18n
  .use(LanguageDetector) // use LanguageDetector
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    debug: import.meta.env.REACT_APP_DEBUG === 'true',

    supportedLngs: [...SUPPORTED_LANGUAGES],
    fallbackLng: 'en',
    load: 'currentOnly',
    lowerCaseLng: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    react: {
      useSuspense: true,
    },
  });

i18n.services.formatter.add('lowercase', (str: string) => str.toLowerCase());

export default i18n;
